import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Interior360 from '../../containers/interior360';
import Interior360Item from '../../blocks/interior360-item';
import PhotoInfo from '../../containers/photo-info';

const Interior360Block = props => <Interior360 {...props} />;
Interior360Block.displayName = 'Interior360';

export default withDynamicComponents({
  componentWhitelist: [
    Interior360Item,
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['interior360Item', 'interior360Item'],
    ['photoInfo', 'photoInfo'],
  ],
})(Interior360Block);




// WEBPACK FOOTER //
// ./src/blocks/interior360/index.jsx